import React, { useState } from "react";
import {
  Button,
  Col,
  FormControl,
  FormLabel,
  Row,
  Table,
} from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  SummaryReportInfoCriteriaBean,
  PostedARRegisterPrintRequest,
  RestPageListBean,
  CustomerSearchCriteria,
  RestReadRequest,
  RestCustomerListRequest,
  FabricStyleSKUBean,
  FabricStyleSearchCriteria,
  RestFabricStyleListRequest,
  RestFabricStyleListBeanRequest,
  SummaryReportInfoPrintRequest,
} from "../ds/ds.js";
import { AddIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
} from "../modules/BaseModule.js";
import {
  PopupFabricStyleModule,
  PopupSalesModule,
  PopupCustomerModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { ReportService } from "../services/ReportService.js";
import { CustomerService } from "../services/CustomerService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import {
  AlertToolBox,
  DatePickerComponent_adv,
  MultiViewPopup,
  ProgressBar,
  ShowError,
  ColumnDefinition,
  InputTextbox,
} from "../gui_components/UIComponents.js";
import CustomTable from "../gui_components/CustomTable.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
class SalesOrderSummaryInfo extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "SalesOrder Summary Info Inquiry",
      isShowExecuteButton: true,
      alertMessage: "",
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowExitButton: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      error_list: [],
      inquiryDataList: [],
      criteria: new SummaryReportInfoCriteriaBean(),
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowCustomerModule: false,
      isShowSalesOrderModule: false,
      isShowFabricStyleModule: false,
      moduleForPopup: [],
      inquiryData: null,
      isDisableFields: false,

      showAutoCompleteCustomerList: false,
      customerPageListForAutoCompleteList: [],
      showAutoCompleteFabricList: false,
      fabricColourPageListForAutoCompleteList: [],
      showAutoCompleteFabricColorList: false,
      fabricColourPageListForAutoCompleteList: [],

      isShowColorLookup: false,
      colorLookupHandler: null,

      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    let criteria = this.state.criteria;

    ModuleUtils.getSalesOrderStatusList();
    ModuleUtils.getSalesOrderLineBeanStatusList();
    this.setState({ criteria: criteria });

    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer",
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      "Fabric Style",
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    criteria.pageList = pageInput;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    // console.log("loadPage criteria..", criteria);
    this.loadSOSummaryInfoInquiryList(criteria);
  };
  loadSOSummaryInfoInquiryList = (criteria) => {
    if (SecurityAccessManager.SalesOrderSummaryInfoInquiry_IsAccessible) {
      ReportService.inquireSummarySalesOrderReportInfos(
        criteria,
        this.loadSOSummaryInfoResponse,
        this.errorCallBack,
      );
    } else {
      this.inValidAccess(1);
    }
  };
  loadSOSummaryInfoResponse = (response) => {
    // console.log("loadPage response..", response);
    this.showErrorMessage(response.data);
    if (!isEmpty(response.data) && !isEmpty(response.data.result)) {
      let soSummaryInfoList = [];
      let inquiryData = null;
      inquiryData = response.data.result;
      if (!isEmptyArray(response.data.result.infoBeans)) {
        soSummaryInfoList = response.data.result.infoBeans;
        let pageList = this.state.pageList;
        pageList.currentPage = response.data.result.currentPage;
        pageList.pageSize = response.data.result.pageSize;
        pageList.totalCount = response.data.result.totalCount;
        this.state.totalPages = Math.ceil(
          pageList.totalCount / pageList.pageSize,
        );
        this.setState({
          isShowPDFButton: false,
          isShowExcelButton: true,
          pageList: pageList,
        });
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        inquiryData: inquiryData,
        isShowClearCriteriaButton: false,
        inquiryDataList: soSummaryInfoList,
        isShowHideButton: false,
        isShowAddButton: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      // this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  generatePDF = () => {
    // this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(1);
  };

  generateReport = (reportType) => {
    let currentDate = new Date();
    currentDate = currentDate.toLocaleDateString("sv-SE");
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new SummaryReportInfoPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.SalesOrderSummaryInfoExcelReport_IsAccessible()
      ) {
        ReportService.generateSummarySalesOrderInfoPrintReport(
          listRequest,
          this.generateSummarySalesOrderInfoPageResponse,
          this.errorCallBack,
        );
      } else {
        this.inValidAccess(2);
      }
    }
  };
  generateSummarySalesOrderInfoPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
    this.hideAlertCallBack();
  };
  clearCriteria = () => {
    let criteria = new SummaryReportInfoCriteriaBean();
    criteria.companyCode = this.companyCode;

    this.setState({ criteria: criteria });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new SummaryReportInfoCriteriaBean();
    criteria.companyCode = this.companyCode;

    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
    });
    this.hideAlertCallBack();
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };

  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteCustomerList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.customerCode = customerData.code;
        criteria.customerName = customerData.description;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readandsetCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomerDetailResponse,
      this.errorCallBack,
    );
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack,
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteCustomerList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };

  /********************Fabric ***************************** */

  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = "";
      criteria.fabricStyleName = "";
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
        colorList: [],
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    this.setState({ isFabricStyleDataLoding: false });
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color",
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    this.setState({ isFabricStyleDataLoding: true });
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack,
    );
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack,
    );
  }
  readByFabricCodeResponse = (response) => {
    if (
      response.data != null &&
      response.data.fabricStylePageList != null &&
      response.data.fabricStylePageList.fabricStyles != null
    ) {
      let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
      let simpleAutoCompleteList = new Array();
      if (fabricStyleData.length > 0 && fabricStyleData != null) {
        fabricStyleData.map((fabricStyle) => {
          let simpleItemBean = {
            code: fabricStyle.fabricStyleCode,
            description: fabricStyle.fabricStyleName,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        fabricPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  fabricEnterKeyEventHandler = (e) => {
    this.readandsetFabricStyleDetail(e.target.value);
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "fabricStyleColorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
    this.fabricStyleColorSelected(e.target.value);
  };
  readFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    criteria.colorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(e.target.value);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    let skuBean = new FabricStyleSKUBean();
    fabricStyle.fabricStyleSkus.map((sku) => {
      if (
        sku.fabricStyleCode == criteria.fabricStyleCode &&
        sku.fabricStyleColorCode == colorCode
      )
        skuBean = sku;
    });
    criteria.fabricStyleColorCode = colorCode;
    this.setState({ criteria: criteria });
  };

  viewSOModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesOrderModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewFabricStyleModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowSalesOrderModule: isOpen,
      isShowCustomerModule: isOpen,
      isShowFabricStyleModule: isOpen,
      moduleForPopup: [],
    });
  };

  onModuleExit = () => {
    this.props.onModuleExit();
  };

  getCaption = (status) => {
    return (
      ModuleUtils.getSalesOrderLineStatusCaption(status) ||
      ModuleUtils.getSalesOrderStatusCaption(status)
    );
  };
  inquiryColumns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "date", true, false, true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SO#", "salesOrderNumber", true, false)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewSOModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer#", "customerCode", true, false)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewCustomerModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "customerName", true, false)
        .setStyleDetails("left", "", "", "wt-8", "wt-8"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("CustPO#", "customerPurchaseOrderNumber", true, false)
        .setStyleDetails("left", "", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("StopDate", "stopDate", true, false, true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Status", "status", true, false)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
        .setStatusDetails(true, this.getCaption),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("FabricStyle#", "fabricStyleCode", true, false)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
        .setClickDetails(true, false, this.viewFabricStyleModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("FabricStyleName", "fabricStyleName", true, false)
        .setStyleDetails("left", "", "", "wt-10", "wt-10"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Color#", "fabricStyleColor", true, false)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Price", "price", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OrderQty", "orderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setSubHeaderDetails(true, "totalQuantity"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Extension", "extension", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setSubHeaderDetails(true, "totalAmount"),
    );

    return columns;
  };

  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let inquiryData = this.state.inquiryData;
    let detailDataList = this.state.detailDataList;
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = pageList.pageSize;
    let totalCount = pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          //   generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          customerCodeOnChange={this.customerCodeOnChange}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteCustomerList={this.displayAutoCompleteCustomerList}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
        />
        {this.state.isInquiryDatasFound ? (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        ) : null}
        {this.state.isInquiryDatasFound && (
          <div className="mt-3 div_default">
            <CustomTable
              data={inquiryDataList}
              columns={this.inquiryColumns()}
              subHeaderData={inquiryData}
            />
          </div>
        )}

        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowSalesOrderModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const onChange = (e) => props.onChange(e);
  let criteria = props.criteria;
  return (
    <div>
      <Row className="d-flex justify-content-left">
        <Col sm="1">
          {" "}
          <FormLabel>FromDate</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent_adv
            name="fromDate"
            value={criteria.fromDate}
            onChange={onChange}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="1">
          <FormLabel>ToDate</FormLabel>
        </Col>
        <Col sm="2">
          <DatePickerComponent_adv
            name="toDate"
            onChange={onChange}
            value={criteria.toDate}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="1">
          <FormLabel>Customer</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            name="customerCode"
            onChange={props.customerCodeOnChange}
            value={criteria.customerCode}
            lookupRequired={true}
            lookupHandler={props.customerLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={props.customerCodeEnterKeyEventHandler}
            autoCompleteListData={props.customerPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={props.displayAutoCompleteCustomerList}
            showAutoCompleteList={props.showAutoCompleteCustomerList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>

        <Col sm="3">
          <InputTextbox
            name="customerName"
            onChange={onChange}
            value={criteria.customerName}
            disabled={true}
          />
        </Col>
      </Row>
      <Row>
        <Col sm="1">
          {" "}
          <FormLabel>FabricStyle</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            name="fabricStyleCode"
            onChange={props.fabricCodeOnChange}
            value={criteria.fabricStyleCode}
            lookupRequired={true}
            lookupHandler={props.fabricLookupHandler}
            showCriteriaDialog={true}
            enterKeyEventHandler={props.fabricEnterKeyEventHandler}
            autoCompleteListData={props.fabricPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={props.displayAutoCompleteFabricList}
            showAutoCompleteList={props.showAutoCompleteFabricList}
            disabled={props.isDisableFields}
            isMandatory={true}
          />
        </Col>
        <Col sm="3">
          <InputTextbox
            name="fabricStyleName"
            onChange={onChange}
            value={criteria.fabricStyleName}
            disabled={true}
          />
        </Col>
        <Col sm="1">
          {" "}
          <FormLabel>Color</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            name="fabricStyleColorCode"
            onChange={props.onFabricColourCodeChange}
            value={criteria.fabricStyleColorCode}
            lookupRequired={props.isShowColorLookup}
            lookupHandler={props.colorLookupHandler}
            enterKeyEventHandler={props.fabricColourEnterKeyEventHandler}
            autoCompleteListData={props.fabricColourPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={props.displayAutoCompleteFabricColorList}
            showAutoCompleteList={props.showAutoCompleteFabricColorList}
            disabled={!props.isShowColorLookup}
          />
        </Col>
        <Col sm="1">
          <FormLabel>Status</FormLabel>
        </Col>
        <Col sm="2">
          <FormControl
            as="select"
            custom
            onChange={props.onChange}
            name="status"
            value={criteria.status}
            disabled={props.isDisableFields}
          >
            <option value={""}>All</option>
            <option value={"A"}>Approved</option>
            <option value={"U"}>UnApproved</option>
            <option value={"X"}>Cancelled</option>
            <option value={"M"}>Picked</option>
            <option value={"L"}>Partially Picked</option>
            <option value={"F"}>Invoiced</option>
            <option value={"G"}>Partially Invoiced</option>
            <option value={"H"}>Close</option>
          </FormControl>
        </Col>
      </Row>
    </div>
  );
}
function SalesOrderSummaryInfoInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <SalesOrderSummaryInfo {...props} name="" /> <br />
    </div>
  );
}
export default SalesOrderSummaryInfoInquiry;
